import { createPersistentState } from './core';

type InitialState = {};

const initialState: InitialState = {};
const persistentStateWrapper = createPersistentState(initialState);

export const {
  persistentState,
  usePersistentState,
  getAtom,
  initializePersistentState,
} = persistentStateWrapper;
export default persistentStateWrapper;
